// extracted by mini-css-extract-plugin
export default {"mCard":"tA-z","image":"uA-z","imageNoBackground":"vA-z","fullWidth":"wA-z"};